import {
  TrackingEventsType,
  UserType,
  UserTypeTranslationMap,
} from '@avanta/shared/types/tracking';
import { type User } from '@avanta/shared/types/users';
import { useTracking } from '../useTracking';
import { type UseTrackingEventsReturn } from './types';

export const useTrackingEvents = (): UseTrackingEventsReturn => {
  const { track } = useTracking();

  const trackUserLogin = (user: User): void => {
    track(TrackingEventsType.USER_LOGIN_COMPLETED, {
      userId: user.id,
      userType: UserTypeTranslationMap[user.type ?? ''] || UserType.PATIENT,
    });
  };

  return {
    trackUserLogin,
  };
};
